module.exports = __webpack_public_path__ + "img/icon_back_simple_yellow.aae7b96b.svg";